@if (loading()) {
  <mbs-loader></mbs-loader>
} @else {
  <mbs-card-group>
    <ng-container *ngTemplateOutlet="logOnTmp"></ng-container>
    <ng-container *ngTemplateOutlet="subscriptionTmp"></ng-container>
  </mbs-card-group>
}

<ng-template #logOnTmp>
  @if (isLogged()) {
    <div class="mbs-form-group">
      <div>
        {{ 'storages:addStorageAccountWizard.inputCredentialsStep.selectASubscription' | i18next }}
      </div>
      <mbs-button
        [attr.data-e2e]="e2eLocators.logIn"
        [isCtrl]="true"
        (click)="logIn()">
        {{ 'storages:addStorageAccountWizard.inputCredentialsStep.switchAccount' | i18next }}
      </mbs-button>
    </div>
  } @else if (!isLogged() && mode === creationMode.Edit) {
    <div class="mbs-form-group">
      <span>{{ 'storages:addStorageAccountWizard.inputCredentialsStep.toModifyAzure' | i18next }}</span>
      {{ ' ' }}
      <mbs-button
        [attr.data-e2e]="e2eLocators.logIn"
        [isCtrl]="true"
        (click)="logIn()"
        >{{ 'storages:addStorageAccountWizard.inputCredentialsStep.login' | i18next }}</mbs-button
      >
      {{ ' ' }}
      <span>{{ 'storages:addStorageAccountWizard.inputCredentialsStep.toAzureAccount' | i18next }}</span>
    </div>
  } @else {
    <div class="d-flex align-items-center justify-content-between">
      <div>
        <mbs-input-label
          [boldLabel]="true"
          [label]="'storages:addStorageAccountWizard.inputCredentialsStep.authorization' | i18next"></mbs-input-label>
        <div class="text-base">{{ 'storages:addStorageAccountWizard.inputCredentialsStep.loginToAzureVM' | i18next }}</div>
      </div>

      <mbs-button
        [attr.data-e2e]="e2eLocators.logIn"
        [type]="'primary'"
        (click)="logIn()"
        >{{ 'storages:addStorageAccountWizard.inputCredentialsStep.login' | i18next: { format: 'capitalize' } }}
      </mbs-button>
    </div>
  }
</ng-template>

<ng-template #subscriptionTmp>
  @if (isLogged() || mode === creationMode.Edit) {
    <div>
      <mbs-select
        [appendTo]="'body'"
        [attr.data-e2e]="e2eLocators.subscriptionDisplayName"
        [bindLabel]="'subscriptionDisplayName'"
        [bindValue]="'subscriptionDisplayName'"
        [boldLabel]="true"
        [clearable]="false"
        [disabledSelf]="!isLogged()"
        [formControl]="subscriptionDisplayName"
        [items]="subscriptions"
        [label]="'storages:addStorageAccountWizard.inputCredentialsStep.labels.subscription' | i18next"
        [showRequiredMark]="false">
      </mbs-select>

      @if (form?.value?.tenantId) {
        <div
          class="mt-1 text-muted"
          [attr.data-e2e]="e2eLocators.tenantId">
          {{ 'storages:addStorageAccountWizard.inputCredentialsStep.labels.tenantID' | i18next }}:
          {{ form?.value?.tenantId }}
        </div>
      }
    </div>
  }
</ng-template>
